import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router';
import { Entente } from '../../../../../../common/src/entities';
import { useGetQuery } from '../../../../Utils/api';
import AffichageChargement from '../../Utils/AffichageChargement';
import { Document, Page, pdfjs } from 'react-pdf';
import { Button, Spinner } from 'react-bootstrap';
import { useLoadPdf } from './LoadEntentePDF';
import EnteteDePage from '../../Utils/EnteteDePage';
import { BiFile } from 'react-icons/bi';
import { useWindowWidth } from '@wojtekmaj/react-hooks';
import { beautifyType } from './CommonHeaderPDF';
import { useRecoilState } from 'recoil';
import { etatMasquerCovid19 } from '../../../../State';

export default function AfficherEntentePDF() {
    const { id, type } = useParams(); // le type est 'soumission', 'reservation', 'bonDeLivraison' ou 'facture'
    const ententeQuery = useGetQuery<Entente>([`ententes/${id}`]);
    const [numPages, setNumPages] = useState(null);
    const [masquerCovid19, setMasquerCovid19] = useRecoilState(etatMasquerCovid19);

    function onDocumentLoadSuccess({ numPages: nextNumPages }) {
        setNumPages(nextNumPages);
    }

    const spinner = (
        <div className="d-flex" style={{ minHeight: '70vh' }}>
            <Spinner animation="border" role="status" className="text-white m-auto">
                <span className="sr-only">Chargement...</span>
            </Spinner>
        </div>
    );

    const options = {
        cMapUrl: `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/cmaps/`,
        cMapPacked: true,
    };

    return (
        <AffichageChargement query={ententeQuery}>
            {function InnerPDF({ data }) {
                const { loading: pdfLoading, data: pdfData } = useLoadPdf(data, type, masquerCovid19.estMasquer);
                const file = useMemo(() => (pdfData ? window.URL.createObjectURL(pdfData) : null), [pdfData]);
                const width = useWindowWidth();

                return (
                    <>
                        <div className="my-4 d-flex align-items-center">
                            <EnteteDePage texte={`Entente - ${data.name} - ${beautifyType(type)}`} iconSize="1.5em" />
                            <div className="ml-auto">
                                <Button
                                    className="d-flex align-items-center"
                                    size="lg"
                                    disabled={pdfLoading}
                                    variant="primary"
                                    href={pdfData ? window.URL.createObjectURL(pdfData) : undefined}
                                    as="a"
                                    download={`Entente - ${data.name} - ${beautifyType(type)}.pdf`}
                                >
                                    {pdfLoading ? (
                                        'Chargement...'
                                    ) : (
                                        <>
                                            <BiFile /> Télécharger le PDF
                                        </>
                                    )}
                                </Button>
                            </div>
                        </div>
                        <div className="bg-secondary py-3">
                            {pdfLoading ? (
                                spinner
                            ) : (
                                <Document
                                    file={file}
                                    onLoadSuccess={onDocumentLoadSuccess}
                                    options={options}
                                    className="d-flex flex-column"
                                    renderMode="svg"
                                    loading={spinner}
                                >
                                    {Array.from(new Array(numPages), (el, index) => (
                                        <Page
                                            className="mx-auto my-2"
                                            key={`page_${index + 1}`}
                                            pageNumber={index + 1}
                                            renderAnnotationLayer={false}
                                            width={Math.min(width * 0.9, 850)}
                                        />
                                    ))}
                                </Document>
                            )}
                        </div>
                    </>
                );
            }}
        </AffichageChargement>
    );
}
